module.exports = __webpack_public_path__ + "assets/media/dots__price.bb2ed9db.svg";